const MobileStoresButtons = ({ buyCoins, googlePlay, appStore }) => (
  <div className="tc t-mb3">
    <p className="t-pv2 f--2 t-ph3-ns lh-copy">{buyCoins}</p>
    <a href={googlePlay.link} target="_blank">
      <img className="t-mr1" src={googlePlay.logo} />
    </a>
    <a href={appStore.link} target="_blank">
      <img className="t-ml1-ns" src={appStore.logo} />
    </a>
  </div>
);

MobileStoresButtons.defaultProps = {
  buyCoins: "Get coins from mobile stores",
  appStore: {
    link: "https://itunes.apple.com/us/app/pop-comics/id1051251000?ls=1&mt=8",
    logo: "/images/webreader/Appstore.svg"
  },
  googlePlay: {
    link: "https://play.google.com/store/apps/details?id=com.popcomics",
    logo: "/images/webreader/Googleplay.svg"
  }
};

export default MobileStoresButtons;
